import { Box, Button, Divider, Grid, Popover, Typography } from '@mui/material';
import React, { useState, MouseEvent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import WSTextField from '../TextBox/WSTextBox';
import WSSelectField from '../Select/WSSelect';
import WSDateField from '../DateField/WSDateField';
import WSMultiCheckBox from '../CheckBox/WSMultiCheckBox';
import { IOptions } from '../Lib/Lib';
import WSRadioField from '../Radio/WSRadio';
import { IsSmallScreen } from '../../commonFunctions/CommonFunctions';
import WSMultiCheckBoxWithApply from '../Select/WSMultiCheckBoxWithApply';

interface IFilterProps {
    rows: IHeaderRows[];
    onFilterChange: (filters: any) => void;
    alignment?: 'left' | 'center' | 'right';
    headerType?: "simple" | "HaderTopCornered"
}

export interface IHeaderRows {
    type: "text" | "checkbox" | "date" | "dropdown" | "radio";
    label: string;
    fieldName: string;
    options?: IOptions[];
    range?: boolean;
    operator?: string;
    align?: 'horizontal' | 'vertical';
    rowDivision?: 3 | 4 | 6 | 12;
}

interface IFilter {
    field: string;
    operator: Operator | string;
    value: string | number;
}

export enum Operator {
    EqualTo = 'eq',
    NotEqualTo = 'neq',
    GreaterThan = 'gt',
    LessThan = 'lt',
    Like = 'like',
}

export const WSHeaderFilter: React.FC<IFilterProps> = React.memo(({ rows, onFilterChange, alignment = 'left', headerType = "simple" }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const methods = useForm();
    const { register, handleSubmit, control, reset, formState: { } } = methods;
    const isMobile = IsSmallScreen();
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        reset();
    };

    const handleReset = () => {

        const emptyValues = rows.reduce((acc, row) => {
            acc[row.fieldName] = ''; // or [] for multi-select/checkbox fields
            return acc;
        }, {} as Record<string, any>);

        // Reset the form with empty values
        reset(emptyValues);

        // Clear filters
        onFilterChange([]);
        reset();
    };

    const open = Boolean(anchorEl);
    const id = open ? 'filter-popover' : undefined;

    const removeEmptyFilters = (filters: any) => {
        return Object.keys(filters).reduce((acc, key) => {
            const value = filters[key];
            if (value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0)) {
                acc[key] = value;
            }
            return acc;
        }, {} as any);
    };

    const onSubmit = (data: any) => {
        const cleanedFilters = removeEmptyFilters(data);
        const appliedFilters = rows.reduce((acc, column) => {
            if (cleanedFilters[column.fieldName]) {
                acc.push({
                    field: column.fieldName,
                    operator: column.operator || Operator.EqualTo,
                    value: Array.isArray(cleanedFilters[column.fieldName])
                        ? cleanedFilters[column.fieldName].join(",")   // or JSON.stringify(...) if you need full string
                        : cleanedFilters[column.fieldName],
                });
            }
            return acc;
        }, [] as IFilter[]);
        onFilterChange(appliedFilters);
        // handleClose();
        setAnchorEl(null);
    };
    const sxHaderTopCornered: any = {
        backgroundColor: '#7D79C2',
        '&:hover': {
            backgroundColor: '#706cae',
        },
    }
    const sxSimple: any = {
        height: 32, width: isMobile ? 20 : undefined
    }
    return (
        <>


            {/* sx={{border:'1px solid red'}} */}
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={1} wrap={rows?.length > 3 ? "wrap" : "nowrap"} alignItems="center"
                        justifyContent="flex-end" sx={{ paddingLeft: 2, paddingTop: 2 }}>
                        {rows.map(({ type, fieldName, label, options, align, rowDivision }) => (
                            <Grid
                                item
                                key={fieldName}
                                sx={{ paddingLeft: 2, paddingTop: 2, minWidth: 200 }} // minWidth ensures it doesn't shrink too small
                            >
                                {type === 'dropdown' && (
                                    <WSMultiCheckBoxWithApply
                                        options={options}
                                        {...register(fieldName)}
                                        id={fieldName}
                                        control={control}
                                        isMobile={isMobile}
                                        label={label}
                                        onChange={handleSubmit(onSubmit)}
                                        name={fieldName}
                                    />
                                )}

                                {type === 'date' && (
                                    <WSDateField
                                        id={fieldName}
                                        name={fieldName}
                                        label={label}
                                        dateFormat="DD-MM-YYYY"
                                        control={control}
                                        isInGridFilter={true}
                                        defaultValue={null}
                                        rules={{ required: false }}
                                    />
                                )}

                                {type === 'checkbox' && (
                                    <WSMultiCheckBox
                                        id={fieldName}
                                        label={label}
                                        name={fieldName}
                                        options={options || []}
                                        align={align}
                                        defaultValue={[]}
                                        rules={{ required: false }}
                                    />
                                )}

                                {type === 'radio' && (
                                    <WSRadioField
                                        id={fieldName}
                                        label={label}
                                        name={fieldName}
                                        align="Horizontal"
                                        options={options || []}
                                        defaultValue={[]}
                                        rules={{ required: false }}
                                        control={control}
                                    />
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </form>
            </FormProvider>


        </>
    );
});
